import React, { useEffect, useRef, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import Scrollbar from '../../../components/custom-scroll/Scrollbar';
import CusQuill from '../../../components/material-ui/CusQuill';
import { API_USERS } from '../../../api/users';
import { getOnlyData } from '../../../utils';
import dayjs from 'dayjs';
import { useInterval } from 'usehooks-ts';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import { updateUserResult } from '../../../store/apps/usersSlice';
import { useDispatch } from 'react-redux';

// 0 - числовой идентификатор сообщения
// 1 - числовой идентификатор автора сообщения
// 2 - имя/логин автора сообщения
// 3 - дата-время сообщения
// 4 - тип сообщения
// 5 - текст сообщения
// 6 - флаг удаленного автора сообщения

export default function WriteTgModal({ open, closeModal, user }) {
  const userLogin = user.login;
  const userId = user.userId;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const scrollbarRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [myMessage, setMyMessage] = useState('');
  const [lastMessage, setLastMessage] = useState();

  const title = `${t('Telegram chat with')} ${userLogin}`;
  const lang = 'ru';

  const updateMessage = async (afterMsgId) => {
    await API_USERS.info.tgChat
      .getMessages({ userId, setReadAll: true, afterMsgId })
      .then((e) => {
        const list = e.data.list;
        const lastMsg = list.at(-1);

        setMessages((prev) => [...prev, ...list]);
        if (lastMsg) setLastMessage(lastMsg[0]);
        dispatch(updateUserResult({ id: userId, dataIndx: 7, value: 0 }));
      })
      .catch(console.error);
  };

  useEffect(() => {
    scrollbarRef.current?.scrollToBottom();
  }, [messages.length]);

  useEffect(() => {
    if (!userId) return;
    if (!open) return;

    setMessages([]);
    updateMessage(null);
  }, [open, userId]);

  useInterval(() => {
    if (open && lastMessage) updateMessage(lastMessage);
  }, 10_000);

  const onSendMessage = () => {
    const msg = myMessage
      .replaceAll('</p><p>', '\n')
      .replaceAll('</p>', '')
      .replaceAll('<p>', '')
      .replaceAll('<br>', '')
      .replaceAll('&nbsp;', ' ')
      .trim();
    API_USERS.info.tgChat
      .sendMes({ userId, msg: msg })
      .then((e) => {
        updateMessage(lastMessage);
        setMyMessage('');
      })
      .catch(console.error);
  };

  const getDate = (date) => getOnlyData(dayjs(date), '', 'DD.MM.YYYY HH:mm:ss');

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="sm"
      saveText="Send"
      contentSx={{ height: '90svh' }}
      onSaveClick={onSendMessage}>
      <Stack gap={2} height={'100%'}>
        <Typography color="textSecondary" fontWeight={600} fontSize={16}>
          {t("The player's language in Telegram is")} {lang}
        </Typography>
        <Scrollbar ref={scrollbarRef} sx={{ maxHeight: 'calc(90svh - 290px)' }}>
          <Stack gap={1}>
            {messages.map((chat) => {
              const mesId = chat[0];
              const mesUserId = chat[1];
              const userLogin = chat[2];
              const dateTime = chat[3];
              const mesType = chat[4];
              const mesText = chat[5];
              const isDeleted = chat[6];

              const isMyMessage = mesType == 3;

              return (
                <Box
                  mb={1}
                  display="flex"
                  alignItems="flex-end"
                  flexDirection={isMyMessage ? 'row-reverse' : 'row'}
                  key={mesId}>
                  <Box alignItems="flex-end" display="flex" flexDirection={'column'}>
                    <Stack
                      flexDirection={isMyMessage ? 'row-reverse' : 'row'}
                      gap={1}
                      mb={1}
                      mr={isMyMessage ? undefined : 'auto'}
                      alignItems={'center'}>
                      {dateTime ? (
                        <Typography variant="body2" color="grey.400" fontSize={11}>
                          {getDate(dateTime)}
                        </Typography>
                      ) : null}

                      <Typography variant="body2" fontWeight={600}>
                        {userLogin}
                      </Typography>
                    </Stack>

                    {/* {chat.type === 'text' ? ( */}
                    <Box
                      mb={1}
                      key={chat.id}
                      sx={{
                        p: 1,
                        backgroundColor: isMyMessage ? 'secondary.light' : 'primary.light',
                        ml: 'auto',
                        width: '100%',
                        maxWidth: '320px',
                        opacity: isDeleted ? 0.7 : 1,
                        position: isDeleted ? 'relative' : ''
                      }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: String(mesText).replaceAll('\n', '<br />')
                        }}
                      />

                      <ShowContainer condition={isDeleted}>
                        <Typography
                          sx={{ position: 'absolute', bottom: 0, right: 0 }}
                          fontSize={12}
                          color="textDisabled">
                          {t('Deleted')}
                        </Typography>
                      </ShowContainer>
                    </Box>
                    {/* ) : null} */}
                    {/* {chat.type === 'image' ? (
                      <Box mb={1} sx={{ overflow: 'hidden', lineHeight: '0px' }}>
                        <img src={chat.msg} alt="attach" width="250" />
                      </Box>
                    ) : null} */}
                  </Box>
                </Box>
              );
            })}
          </Stack>
        </Scrollbar>
        <Stack direction={'column'} gap={1} mt={'auto'}>
          <Box>
            <CusQuill
              key={'mes-text-' + lang}
              isTgMode
              autoFocus={open}
              value={myMessage}
              onChange={setMyMessage}
              height="200px"
            />
          </Box>
        </Stack>
      </Stack>
    </InfoDialog>
  );
}
